<template lang="pug"
src='./compliance.pug'>

</template>

<script>
import Contact from 'Common/components/party/person.vue'
import _ from 'lodash'
import saveBtn from '@/common/components/saveBtn.vue'
import {EventBus} from 'CommonApp/event-bus'
import Vue from 'vue'

export default {
	name: 'compliance',
	components: {Contact, saveBtn},
	props: ['project', 'control', 'contacts', 'validContacts', 'readonly'],
	data () {
		return {
			priority: [1, 2, 3, 4, 5, 6, 7, 8],
			actionLegendNew: 'if your design does not pass compliance on the first run, please indicate <b>at least 4</b> and up to 8 preferred actions to bring your project into compliance, and their relative priority, "1" being the highest priority. Please do not repeat actions, except "Boost" actions, which are cumulative',
			actionLegendAdd: 'if your design does not pass compliance on the first run, please indicate <b>at least 6</b> and up to 20 preferred actions to bring your project into compliance, and their relative priority, "1" being the highest priority. Please do not repeat actions, except "Boost" actions, which are cumulative',
			dataReady: false,
			enableDM: false,
			complianceActionsNumber: 0,
			projType: {}
		}
	},
	beforeCreate: function () {},
	created: function () {
		// console.debug('Project contacts', this.contacts)
		this.enableDM = !this.project.sgnrIsDcsnMkr
		this.appearDeleteBtn()
		this.projType = process.env.PROJTYPE
		if (this.project.takeoff === this.projType.remodel) {
			Vue.e24.formService.findControlByForm(['prefs'], 'ePlusAdd').then((control) => {
				this.control.addPrefCompl = control.addPrefCompl
			})
		}
	},
	methods: {
		changeSgnrIsDcsnMkr (value) {
			const dm = _.find(this.contacts, (contact) => { return (contact.object.typeId === 'DM') })
			if (!value) {
				if (!dm) {
					console.log('DM NOT FOUND', this.contacts)
					EventBus.$emit('createDecisionMakerContact')
				}
				this.enableDM = true
			} else {
				this.enableDM = false
			}
		},
		addPreference () {
			this.project.preference.compActions.push({
				action: '',	// hiEffWatr
				priority: 1
			})
		},
		deletePreference (index) {
			this.project.preference.compActions.splice(index, 1)
		},
		showModalFromInfo (value) {
			EventBus.$emit('open-compliance-company-name-popUp', value)
		},
		appearDeleteBtn () {
			let project = this.project.isNewHome
			if (project) {
				this.complianceActionsNumber = 4
				return 4
			} else {
				this.complianceActionsNumber = 6
				return 6
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/take-off-tool/tabs-components/compliance.vue